const areas = [
  { city: 'Palm Coast', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
  { city: 'Ormond Beach', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
  { city: 'Daytona Beach', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
  { city: 'Port Orange', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
  { city: 'New Smyrna Beach', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
  { city: 'Edgewater', state: 'FL', services: ['Fencing', 'Pavers', 'Landscape', 'Lighting', 'Sheds'] },
];

export default function ServiceAreasSection() {
  return (
    <section className="bg-cream py-28 px-6">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-gold font-sans text-[11px] font-semibold tracking-[0.28em] uppercase mb-4 flex items-center gap-3 justify-center">
            <span className="h-px w-8 bg-gold inline-block"></span>
            Local Coverage
          </p>
          <h2 className="font-serif text-charcoal font-bold mb-4" style={{ fontSize: 'clamp(32px, 3.2vw, 48px)' }}>
            Areas We Proudly Serve
          </h2>
          <p className="text-charcoal-muted text-base max-w-2xl mx-auto leading-relaxed">
            Dippel&apos;s Outdoor Services delivers premium fencing, pavers, landscape installation, and outdoor lighting throughout Volusia and Flagler County — from Palm Coast to Edgewater and everywhere in between.
          </p>
        </div>

        <div className="grid lg:grid-cols-5 gap-8 items-start">
          {/* Map — larger */}
          <div className="lg:col-span-3 rounded-2xl overflow-hidden border border-stone-dark" style={{ height: '520px' }}>
            <iframe
              title="Dippel's Outdoor Services — Florida service area map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d221576.2729994!2d-81.2453!3d29.0228!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88e73fb6defa2f9b%3A0xa7948486a71768ac!2sDippel%27s%20Outdoor%20Services!5e0!3m2!1sen!2sus!4v1710000000000"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>

          {/* Areas + contact */}
          <div className="lg:col-span-2 space-y-3">
            {areas.map((area) => (
              <div
                key={area.city}
                className="group bg-white border border-stone-dark rounded-xl px-5 py-4 hover:border-forest/25 hover:bg-forest/3 transition-all"
              >
                <div className="flex items-center justify-between mb-2">
                  <div className="flex items-center gap-2.5">
                    <i className="ri-map-pin-2-fill text-forest text-sm"></i>
                    <h3 className="font-serif text-base font-semibold text-charcoal">
                      {area.city},{' '}
                      <span className="text-charcoal-muted font-normal text-sm">{area.state}</span>
                    </h3>
                  </div>
                  <i className="ri-arrow-right-s-line text-charcoal/30 group-hover:text-forest transition-colors"></i>
                </div>
                <div className="flex flex-wrap gap-1.5">
                  {area.services.map((svc) => (
                    <span
                      key={svc}
                      className="text-[11px] bg-stone text-charcoal-muted border border-stone-dark px-2 py-0.5 rounded-full font-medium"
                    >
                      {svc}
                    </span>
                  ))}
                </div>
              </div>
            ))}

            {/* Contact block */}
            <div className="bg-charcoal text-white rounded-xl p-5 flex items-start gap-4 mt-2">
              <div className="w-10 h-10 flex items-center justify-center bg-gold/20 rounded-lg flex-shrink-0">
                <i className="ri-phone-fill text-gold text-base"></i>
              </div>
              <div>
                <p className="font-semibold text-white text-sm mb-0.5">Don&apos;t see your city?</p>
                <p className="text-white/45 text-xs mb-3 leading-relaxed">We may still be able to serve you — give us a call.</p>
                <a
                  href="tel:3863014399"
                  className="text-gold font-bold hover:text-gold-light transition-colors text-sm whitespace-nowrap"
                >
                  (386) 301-4399
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
